export const BREAKPOINTS = {
	1: {
		freeMode: false,
		slidesPerView: 1,
	},
	744: {
		freeMode: {
			enabled: true,
			sticky: true,
		},
		slidesPerView: 1.75,
	},
	1039: {
		freeMode: false,
		slidesPerView: 1,
	},
};

export const LAZY_PRELOAD_IMAGES = 4;
export const SPACE_BETWEEN_SLIDES = 16;

export const DESKTOP_SIZE_BREAKPOINT = 1039;

export const IMAGE_SIZE = {
	DESKTOP: 920,
	TABLET: 690,
	THUMB: 160,
};
